import { useState } from "react";
import { Box, Fade, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CustomColoredTabs } from "../../CustomColoredTabs/CustomColoredTabs.component";
import { CustomColoredTab } from "../../CustomColoredTabs/CustomColoredTab.component";
import { TabPanel } from "../../../features/TabPanel/TabPanel.component";
import { a11yProps } from "../../../features/TabPanel/TabPanel.partial";
import { OrderRequestList } from "./OrderRequestList.component";

/**
 * @version 0.1.0
 */
export const OrderRequestManagement = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const [tabState, setTabState] = useState(0);
  /* istanbul ignore next */
  const handleTabChange = (event: React.SyntheticEvent<{}>, newValue: number) =>
    setTabState(newValue);

  return (
    <Fade in>
      <Box
        sx={{ "& > *": { margin: theme.spacing(1) } }}
        data-testid="service-order-requests-tabs-parent"
      >
        <CustomColoredTabs value={tabState} onChange={handleTabChange}>
          <CustomColoredTab
            index={0}
            // theme={theme}
            data-testid={"order-reqeust-tab"}
            label={t("Manage Orders")}
            {...a11yProps(0)}
          />
        </CustomColoredTabs>
        {/* list of order requests */}
        <TabPanel value={tabState} index={0} paddingStyle={"0"}>
          <OrderRequestList />
        </TabPanel>
      </Box>
    </Fade>
  );
};
